import React from 'react'

export const ComponentToPrintAllShopReport = React.forwardRef(({title, data, title1, data1, title2, data2}, ref) => {
  const convertDate = (dateStr) => {
    const d = new Date(dateStr);
    return d.getDate() + "/" + (d.getMonth() + 1) + "/" +  d.getFullYear();
  }
  return (
    <div ref={ref}>
      <div>
        <center>
        <br />
        <b>{title}</b><br />
        <table width="100%">
            <tbody>
              <tr>
                <td colSpan="10"><hr /></td>
              </tr>
              <tr>
                <th />
                <th align="left">#</th>
                <th align="left">Date</th>
                <th align="right">Cash</th>
                <th align="right">Card</th>
                <th align="right">UPI</th>
                <th align="right">Total</th>
                <th align="right">Cancel</th>
                <th align="right">Net</th>
                <th />
              </tr>
              <tr>
                <td colSpan="10"><hr /></td>
              </tr>
              {data.map((item, index) => (
                <tr key={item._id}>
                  <td />
                  <td align="left">{index + 1}</td>
                  <td align="left">{convertDate(item._id)}</td>
                  <td align="right">{item.cash}</td>
                  <td align="right">{item.card}</td>
                  <td align="right">{item.upi}</td>
                  <td align="right">{item.total}</td>
                  <td align="right">{item.with_cancel}</td>
                  <td align="right">{item.without_cancel}</td>
                  <td />
                </tr>
              ))}
              <tr>
                <td colSpan="10"><hr /></td>
              </tr>
            </tbody>   
        </table>
      </center>
      </div>
      <div>
        <center>
        <br />
        <b>{title1}</b><br />
        <table width="100%">
            <tbody>
              <tr>
                <td colSpan="10"><hr /></td>
              </tr>
              <tr>
                <th />
                <th align="left">#</th>
                <th align="left">Date</th>
                <th align="right">Cash</th>
                <th align="right">Card</th>
                <th align="right">UPI</th>
                <th align="right">Total</th>
                <th align="right">Cancel</th>
                <th align="right">Net</th>
                <th />
              </tr>
              <tr>
                <td colSpan="10"><hr /></td>
              </tr>
              {data1.map((item, index) => (
                <tr key={item._id}>
                  <td />
                  <td align="left">{index + 1}</td>
                  <td align="left">{convertDate(item._id)}</td>
                  <td align="right">{item.cash}</td>
                  <td align="right">{item.card}</td>
                  <td align="right">{item.upi}</td>
                  <td align="right">{item.total}</td>
                  <td align="right">{item.with_cancel}</td>
                  <td align="right">{item.without_cancel}</td>
                  <td />
                </tr>
              ))}
              <tr>
                <td colSpan="10"><hr /></td>
              </tr>
            </tbody>   
        </table>
      </center>
      </div>
      <div>
        <center>
        <br />
        <b>{title2}</b><br />
        <table width="100%">
            <tbody>
              <tr>
                <td colSpan="10"><hr /></td>
              </tr>
              <tr>
                <th />
                <th align="left">#</th>
                <th align="left">Date</th>
                <th align="right">Cash</th>
                <th align="right">Card</th>
                <th align="right">UPI</th>
                <th align="right">Total</th>
                <th align="right">Cancel</th>
                <th align="right">Net</th>
                <th />
              </tr>
              <tr>
                <td colSpan="10"><hr /></td>
              </tr>
              {data2.map((item, index) => (
                <tr key={item._id}>
                  <td />
                  <td align="left">{index + 1}</td>
                  <td align="left">{convertDate(item._id)}</td>
                  <td align="right">{item.cash}</td>
                  <td align="right">{item.card}</td>
                  <td align="right">{item.upi}</td>
                  <td align="right">{item.total}</td>
                  <td align="right">{item.with_cancel}</td>
                  <td align="right">{item.without_cancel}</td>
                  <td />
                </tr>
              ))}
              <tr>
                <td colSpan="10"><hr /></td>
              </tr>
            </tbody>   
        </table>
      </center>
      </div>
    </div>
  )
});
